import React from 'react'

import Mobile from "./../../../UI/topMenu/contactanos.svg"

interface Props {
  colorsData: any
  handleOpenContactModal: any
}

interface State {}

class ContactBtnMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props)
    this.state = {}
  }

  render(): React.ReactNode {
      return(
        <div 
          className='contact-btn-mobile'
          style={{
            backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons:""
          }}
          onClick = {() => {
            this.props.handleOpenContactModal()
          }}
        >
          <img src={Mobile} alt=""></img>
          <div className="contact-title-mobile">Contáctanos</div>
        </div>
      )
  }
}

export default ContactBtnMobile